// @ts-nocheck

export enum ServerType {
  FTP = "FTP",
  SFTP = "SFTP",
}

export enum StockTransferType {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

export enum RoleType {
  USER = "USER",
  EDITOR = "EDITOR",
  CLIENT_ADMINISTRATOR = "CLIENT_ADMINISTRATOR",
  ADMINISTRATOR = "ADMINISTRATOR",
  INSTALLER = "INSTALLER",
}

export enum ServerEnvironmentType {
  TEST = "TEST",
  PRODUCTION = "PRODUCTION",
}

export enum CreationType {
  UNKNOWN = "UNKNOWN",
  MASTER_DATA = "MASTER_DATA",
  IMPORT = "IMPORT",
  CONFIGURATION = "CONFIGURATION",
  MANUAL = "MANUAL",
  CSV_IMPORT = "CSV_IMPORT",
  KLAES_IMPORT = "KLAES_IMPORT",
}

export enum ModuleType {
  SHOPPING_CART = "SHOPPING_CART",
}

export enum LaminationType {
  EMPTY = "EMPTY",
  NOT_SPECTRAL = "NOT_SPECTRAL",
  SPECTRAL = "SPECTRAL",
  BOTH = "BOTH",
}

export enum OrderType {
  EDI = "EDI",
  MANUAL = "MANUAL",
  MAIL = "MAIL",
}

export enum RequestSort {
  CUSTOMER = "CUSTOMER",
  ARTICLE = "ARTICLE",
  MATERIAL_GROUP = "MATERIAL_GROUP",
  CATEGORY = "CATEGORY",
  SALE = "SALE",
  REQUEST_SALE = "REQUEST_SALE",
  STATE = "STATE",
  STOCK_EXTRACTION = "STOCK_EXTRACTION",
}

export enum ReportType {
  REQUEST = "REQUEST",
  ORDER = "ORDER",
  STOCK = "STOCK",
  SALE = "SALE",
}

export enum StockLogMethod {
  UNKNOWN = "UNKNOWN",
  REQUEST_POSITION_DELETE = "REQUEST_POSITION_DELETE",
  REQUEST_POSITION_CANCEL_REQUEST_POSITION = "REQUEST_POSITION_CANCEL_REQUEST_POSITION",
  REQUEST_POSITION_UPDATE = "REQUEST_POSITION_UPDATE",
  REQUEST_POSITION_CREATE = "REQUEST_POSITION_CREATE",
  REQUIRED_STOCK_UPDATE = "REQUIRED_STOCK_UPDATE",
  ORDER_POSITION_DELETE = "ORDER_POSITION_DELETE",
  ORDER_POSITION_UPDATE_ORDER_POSITION = "ORDER_POSITION_UPDATE_ORDER_POSITION",
  STOCK_MAP_DATA = "STOCK_MAP_DATA",
  STOCK_REFRESH_STOCK_VALUES = "STOCK_REFRESH_STOCK_VALUES",
  STOCK_RECEIPT_ORDER_POSITION = "STOCK_RECEIPT_ORDER_POSITION",
  STOCK_UPDATE_STOCK = "STOCK_UPDATE_STOCK",
  STOCK_CLEAR_ALMOST_EMPTY_STOCK = "STOCK_CLEAR_ALMOST_EMPTY_STOCK",
  ORDER_ADD_UNASSIGNED_REQUEST_POSITIONS = "ORDER_ADD_UNASSIGNED_REQUEST_POSITIONS",
  ORDER_SUBMIT_ELECTRONIC_ORDER = "ORDER_SUBMIT_ELECTRONIC_ORDER",
  ORDER_CLOSE_ORDER_POSITIONS = "ORDER_CLOSE_ORDER_POSITIONS",
  ORDER_ADD_AMOUNT_TO_OPEN_ORDER = "ORDER_ADD_AMOUNT_TO_OPEN_ORDER",
  ORDER_ORDER_ORDER = "ORDER_ORDER_ORDER",
  AUTOMATED_REQUEST_AUTO_PROCESS_REQUEST = "AUTOMATED_REQUEST_AUTO_PROCESS_REQUEST",
  SUPPLIER_CONDITION_PROCESS_CREATE = "SUPPLIER_CONDITION_PROCESS_CREATE",
  REQUEST_EXTRACT_REQUEST_POSITION = "REQUEST_EXTRACT_REQUEST_POSITION",
  STOCK_TRANSFER_ENTRY_BOOK_INCOMING_TRANSFER = "STOCK_TRANSFER_ENTRY_BOOK_INCOMING_TRANSFER",
  STOCK_TRANSFER_ENTRY_BOOK_INCOMING_FOR_ORDER = "STOCK_TRANSFER_ENTRY_BOOK_INCOMING_FOR_ORDER",
  STOCK_TRANSFER_ENTRY_BOOK_OUTGOING_FOR_REQUEST = "STOCK_TRANSFER_ENTRY_BOOK_OUTGOING_FOR_REQUEST",
  STOCK_TRANSFER_ENTRY_BOOK_OUTGOING_FOR_COMMENT = "STOCK_TRANSFER_ENTRY_BOOK_OUTGOING_FOR_COMMENT",
  INVENTORY_CONTINUE = "INVENTORY_CONTINUE",
  INVENTORY_FINISH = "INVENTORY_FINISH",
  INVENTORY_INTERRUPT = "INVENTORY_INTERRUPT",
  RESET_STOCK_VALUE = "RESET_STOCK_VALUE",
  UPDATE_SUBSTITUTE_STOCK = "UPDATE_SUBSTITUTE_STOCK",
  PRODUCT_UPDATE_MANUAL = "PRODUCT_UPDATE_MANUAL",
  ORDER_ADD_COMMISSION_REQUEST_POSITION = "ORDER_ADD_COMMISSION_REQUEST_POSITION",
  TRANSFER_DISCONTINUED_PRODUCT = "TRANSFER_DISCONTINUED_PRODUCT",
}

export enum MessageType {
  note = "note",
  warn = "warn",
  error = "error",
}

export enum ServerConfigurationType {
  OPENTRANS = "OPENTRANS",
  BMECAT = "BMECAT",
}

export enum ImportType {
  BMECAT = "BMECAT",
  KLAES = "KLAES",
  CSV = "CSV",
}

export enum SaleSort {
  SUPPLIER = "SUPPLIER",
  ARTICLE = "ARTICLE",
  MATERIAL_GROUP = "MATERIAL_GROUP",
  CATEGORY = "CATEGORY",
  SUMMARY = "SUMMARY",
}

export enum VaasOrderStatus {
  INITIAL = "INITIAL",
  GREEN = "GREEN",
  YELLOW = "YELLOW",
  RED = "RED",
}

export enum OpenTransParty {
  OTHER = "OTHER",
  VEKA = "VEKA",
  GEALAN = "GEALAN",
}

export enum OrderDeliveryStatus {
  OVERDUE = "OVERDUE",
  PARTIAL_DELIVERED = "PARTIAL_DELIVERED",
  FULL_DELIVERED = "FULL_DELIVERED",
}

export enum Type {
  ORDER_WITHDRAWAL = "ORDER_WITHDRAWAL",
  RELEASE_NOTE = "RELEASE_NOTE",
  SUPPLIER_SERVER_CONNECTION_FAILURE = "SUPPLIER_SERVER_CONNECTION_FAILURE",
}

export enum StockSort {
  MATERIAL_GROUP = "MATERIAL_GROUP",
  ARTICLE = "ARTICLE",
  AMOUNT = "AMOUNT",
  PRICE_VALUE = "PRICE_VALUE",
  CATEGORY = "CATEGORY",
}

export enum MessageKey {
  REQUEST_EXTRACTION_ALREADY_EXTRACTED = "REQUEST_EXTRACTION_ALREADY_EXTRACTED",
  REQUEST_EXTRACTION_REQUIREMENT_MADE_MISSES = "REQUEST_EXTRACTION_REQUIREMENT_MADE_MISSES",
  REQUEST_EXTRACTION_REQUEST_NOT_EXISTS = "REQUEST_EXTRACTION_REQUEST_NOT_EXISTS",
  REQUEST_EXTRACTION_NEGATIVE_VALUES = "REQUEST_EXTRACTION_NEGATIVE_VALUES",
  REQUEST_EXTRACTION_SUCCEED = "REQUEST_EXTRACTION_SUCCEED",
  RELEASE_NOTES = "RELEASE_NOTES",
  SUPPLIER_SERVER_CONNECTION_DISABLED = "SUPPLIER_SERVER_CONNECTION_DISABLED",
}

export enum StockLogType {
  EXCLUDED = "EXCLUDED",
  RESERVED_AMOUNT = "RESERVED_AMOUNT",
  ORDERED_AMOUNT = "ORDERED_AMOUNT",
  ORDER_REQUIREMENT = "ORDER_REQUIREMENT",
  INPUT = "INPUT",
  OUTPUT = "OUTPUT",
  MANUAL = "MANUAL",
  DELETE = "DELETE",
  ALMOST_EMPTY_CORRECTION = "ALMOST_EMPTY_CORRECTION",
  INVENTORY = "INVENTORY",
  REQUEST_POS_ADD_MANUAL = "REQUEST_POS_ADD_MANUAL",
  REQUEST_POS_ADD_IMPORT = "REQUEST_POS_ADD_IMPORT",
  REQUEST_POS_CHANGE = "REQUEST_POS_CHANGE",
  REQUEST_POS_DELETE = "REQUEST_POS_DELETE",
  REQUEST_POS_CANCELED = "REQUEST_POS_CANCELED",
  REQUIREMENT_ADD = "REQUIREMENT_ADD",
  REQUIREMENT_IN_EXCLUDED = "REQUIREMENT_IN_EXCLUDED",
  ORDER_POS_ADD_MANUAL = "ORDER_POS_ADD_MANUAL",
  ORDER_POS_ADD = "ORDER_POS_ADD",
  ORDER_POS_DELETE = "ORDER_POS_DELETE",
  ORDER_POS_CHANGE = "ORDER_POS_CHANGE",
  ORDER_POS_ORDERED = "ORDER_POS_ORDERED",
  DELIVERY_BOOKED = "DELIVERY_BOOKED",
  GOODS_RECEIPT_BOOKED = "GOODS_RECEIPT_BOOKED",
  REQUEST_EXTRACTED = "REQUEST_EXTRACTED",
  MIN_STOCK = "MIN_STOCK",
  MAX_STOCK = "MAX_STOCK",
  CURRENT_STOCK = "CURRENT_STOCK",
  PRODUCT_VARIANT_ADD_CHANGE_MANUAL = "PRODUCT_VARIANT_ADD_CHANGE_MANUAL",
  PRODUCT_VARIANT_ADD_STOCK_MANUAL = "PRODUCT_VARIANT_ADD_STOCK_MANUAL",
  PRODUCT_VARIANT_SUB_STOCK_MANUAL = "PRODUCT_VARIANT_SUB_STOCK_MANUAL",
  PRODUCT_VARIANT_DELETE = "PRODUCT_VARIANT_DELETE",
  INVENTORY_START = "INVENTORY_START",
  INVENTORY_STOP = "INVENTORY_STOP",
  INVENTORY_CONTINUE = "INVENTORY_CONTINUE",
  REQUEST_POS_MANUAL_ADD_CHANGE = "REQUEST_POS_MANUAL_ADD_CHANGE",
  ORDER_POS_ADD_CHANGE = "ORDER_POS_ADD_CHANGE",
  ORDER_POS_ADD_AUTO = "ORDER_POS_ADD_AUTO",
  ORDER_POS_CLOSED = "ORDER_POS_CLOSED",
  ORDER_POS_EDI_ORDERED = "ORDER_POS_EDI_ORDERED",
  ORDER_POS_MANUAL_ORDERED = "ORDER_POS_MANUAL_ORDERED",
  CHANGE_SUPPLIER_CONDITION = "CHANGE_SUPPLIER_CONDITION",
  PRODUCT_VARIANT_ADD_TRANSFER_LIST = "PRODUCT_VARIANT_ADD_TRANSFER_LIST",
  PRODUCT_VARIANT_REMOVE_TRANSFER_LIST = "PRODUCT_VARIANT_REMOVE_TRANSFER_LIST",
  PRODUCT_SUBSTITUTION_ADD = "PRODUCT_SUBSTITUTION_ADD",
  TRANSFER_STOCK = "TRANSFER_STOCK",
}

export enum ImportStatus {
  IGNORED = "IGNORED",
  NOT_PLANNED = "NOT_PLANNED",
  PLANNED = "PLANNED",
  IMPORTED = "IMPORTED",
  IMPORT_ERROR = "IMPORT_ERROR",
}

export enum OrderSort {
  DELIVERY_DATE = "DELIVERY_DATE",
  ARTICLE = "ARTICLE",
  MATERIAL_GROUP = "MATERIAL_GROUP",
  SALE = "SALE",
  SUPPLIER_SALE = "SUPPLIER_SALE",
  STATE = "STATE",
}

export enum ImportRequestLogStatus {
  NEW = "NEW",
  OVERWRITTEN = "OVERWRITTEN",
  ERROR = "ERROR",
}

export interface SystemSetting {
  ParamKey: string | null;
  Visible: boolean | null;
  Guid: string | null;
  Label: string | null;
  ParamValue: string | null;
}

export interface DeliveryNotePositionPackage {
  DeliveryNotePositionGuid: string | null;
  OrderNumber: string | null;
  OrderedCarrier: string | null;
  OrderedInnerLamination: string | null;
  DeliveredUnits: number | null;
  OrderedBaseAmount: number | null;
  DeliveredOuterLamination: string | null;
  SupplierPID: string | null;
  ConfirmedUnits: number | null;
  PackageNumber: string | null;
  BaseUnit: string | null;
  OrderPositionNumber: string | null;
  OrderGuid: string | null;
  ArticleNumber: string | null;
  DeliveredBaseAmount: number | null;
  ConfirmedUnit: string | null;
  DeliveredUnit: string | null;
  ArticleName: string | null;
  OrderedUnit: string | null;
  DeliveredInnerLamination: string | null;
  DescriptionShort: string | null;
  OrderedOuterLamination: string | null;
  OrderedUnits: number | null;
  DeliveredCarrier: string | null;
  OrderPositionGuid: string | null;
  DeliveryNoteGuid: string | null;
  Guid: string | null;
  OrderPositionAmount: number | null;
  PositionIndex: number | null;
  VariantName: string | null;
  OrderedPID: string | null;
  DeliveryNoteNumber: string | null;
}

export interface Seal {
  Number: string | null;
  DisplayName: string | null;
  Name: string | null;
  Guid: string | null;
}

export interface SystemUser {
  FirstName: string | null;
  IsEmailCCEnabled: boolean | null;
  LastName: string | null;
  PhoneNumber: string | null;
  UserFullName: string | null;
  Guid: string | null;
  Language: string | null;
  Disabled: boolean | null;
  UserName: string | null;
  Email: string | null;
  UserRoleDetails?: Array<UserRole>;
}

export interface ProductCategory {
  Description: string | null;
  Guid: string | null;
  CategoryArticleMappingDetails?: Array<ProductCategoryArticleMapping>;
}

export interface ProductTemplate {
  ArticleGuid: string | null;
  SealGuid: string | null;
  CarrierGuid: string | null;
  BaseUnitGuid: string | null;
  GeometryGuid: string | null;
  Guid: string | null;
  AdditionalEquipmentGuid: string | null;
  SealColorGuid: string | null;
  InnerLaminationGuid: string | null;
  BaseAmount: number | null;
  OuterLaminationGuid: string | null;
}

export interface ShoppingCart {
  Amount: number | null;
  ArticleName: string | null;
  OrderPositionGuid: string | null;
  ProductGuid: string | null;
  Guid: string | null;
  UserGuid: string | null;
  Barcode: string | null;
  ProductName: string | null;
}

export interface ImportData {
  ColorNumber: string | null;
  Seal: string | null;
  Description: string | null;
  MillimeterValues: boolean | null;
  RequestNumber: string | null;
  ProductionDate: string | null;
  UnitLength: number | null;
  ArticleNumber: string | null;
  Property: string | null;
  InnerLamination: string | null;
  FileFormatGuid: string | null;
  VekaId: string | null;
  Addition: string | null;
  Height: number | null;
  Amount: number | null;
  SealColor: string | null;
  Length: number | null;
  IsArticleNumberGenerated: boolean | null;
  OuterLamination: string | null;
  Carrier: string | null;
  Size: number | null;
  Width: number | null;
  Guid: string | null;
  Geometry: string | null;
  Position: number | null;
  RequestGuid: string | null;
}

export interface SystemMessage {
  Date: string | null;
  Unread: boolean | null;
  Guid: string | null;
  Text: string | null;
  Type: MessageType | null;
}

export interface BmecatConfiguration {
  InnerSpectralFeatureName: string | null;
  SupplierGuid: string | null;
  DefaultPackingCode: string | null;
  ArticleNumberFeatureName: string | null;
  GeometryFeatureName: string | null;
  PackingFeatureName: string | null;
  ImportedCatalogVersion: string | null;
  TotalSpectralFeatureName: string | null;
  ImportedLanguage: string | null;
  OuterSpectralFeatureName: string | null;
  SealColorFeatureName: string | null;
  CarrierFeatureName: string | null;
  TotalLaminationFeatureName: string | null;
  SealFeatureName: string | null;
  ImportedTemplates: number | null;
  InnerLaminationFeatureName: string | null;
  LastBmecatImportDate: string | null;
  LastBmecatGenerationDate: string | null;
  ImportedCatalogName: string | null;
  OuterLaminationFeatureName: string | null;
  Guid: string | null;
  ImportedVariants: number | null;
  AdditionalEquipmentFeatureName: string | null;
  ImportedCatalogId: string | null;
  SupplierDetail?: Supplier | null;
}

export interface DeliveryTimeCode {
  SupplierGuid: string | null;
  Code: string | null;
  Days: number | null;
  Guid: string | null;
}

export interface RequestPositionDelivery {
  Guid: string | null;
  DeliveryNoteNumber: string | null;
  PackageNumber: string | null;
  RequestPositionDetail?: RequestPosition | null;
}

export interface ImportRequestLog {
  RequestNumber: string | null;
  Guid: string | null;
  Time: string | null;
  Status: ImportRequestLogStatus | null;
}

export interface ProductCategoryArticleMapping {
  ArticlesGuid: string | null;
  CategoriesGuid: string | null;
  Guid: string | null;
  CategoryDetail?: ProductCategory | null;
  ArticleDetail?: Article | null;
}

export interface StockLog {
  ArticleGuid: string | null;
  ReservedAmount: number | null;
  OrderRequirement: number | null;
  ArticleName: string | null;
  ExecutingLogin: string | null;
  OrderNumber: string | null;
  Method: StockLogMethod | null;
  LogDate: string | null;
  BaseUnitDecimalValue: boolean | null;
  ProductGuid: string | null;
  BaseUnitName: string | null;
  Type: StockLogType | null;
  MinStock: number | null;
  RequestNumber: string | null;
  OrderPositionIndex: number | null;
  ArticleNumber: string | null;
  ExcludeRequirement: boolean | null;
  BaseUnitGuid: string | null;
  NewStock: number | null;
  CurrentStock: number | null;
  Guid: string | null;
  VariantName: string | null;
  OrderedAmount: number | null;
  OldStock: number | null;
}

export interface Carrier {
  Number: string | null;
  CreationType: CreationType | null;
  DisplayName: string | null;
  Name: string | null;
  Guid: string | null;
  SapId: string | null;
}

export interface Geometry {
  Number: string | null;
  DisplayName: string | null;
  Name: string | null;
  Guid: string | null;
}

export interface ClientSetting {
  ParamKey: string | null;
  Visible: boolean | null;
  Guid: string | null;
  Label: string | null;
  ParamValue: string | null;
}

export interface Article {
  Suppliers: string | null;
  MaterialGroupGuid: string | null;
  Description: string | null;
  ProductGroupGuid: string | null;
  MaterialGroupName: string | null;
  BmecatArticle: boolean | null;
  ProductCategoryGuids: string | null;
  Number: string | null;
  ProductGroupDescription: string | null;
  Name: string | null;
  Guid: string | null;
  IsDisabled: boolean | null;
  ProductCategoryNames: string | null;
  ProductCategoryDetails?: Array<ProductCategory>;
  ProductGroupDetail?: ProductGroup | null;
  MaterialGroupDetail?: MaterialGroup | null;
  SupplierConditionDetails?: Array<SupplierCondition>;
  StockDetails?: Array<Stock>;
  ProductDetails?: Array<Product>;
}

export interface SupplierRecipientNumber {
  SupplierGuid: string | null;
  Guid: string | null;
  Element: string | null;
  SupplierDetail?: Supplier | null;
}

export interface ImportFileFormat {
  ProductionDatePosition: number | null;
  HeightPosition: number | null;
  DescriptionPosition: number | null;
  AmountLength: number | null;
  Placeholder2Position: number | null;
  PieceIsPair: boolean | null;
  VekaIdLength: number | null;
  WidthPosition: number | null;
  CarrierLength: number | null;
  AdditionPosition: number | null;
  ColorNumberPosition: number | null;
  UnitLengthPosition: number | null;
  SealLength: number | null;
  HeightLength: number | null;
  PositionLength: number | null;
  GeometryLength: number | null;
  OuterLaminationPosition: number | null;
  LengthLength: number | null;
  Replacing: boolean | null;
  RequestNumberLength: number | null;
  LengthPosition: number | null;
  SealColorPosition: number | null;
  Guid: string | null;
  SealColorLength: number | null;
  PositionPosition: number | null;
  CarrierPosition: number | null;
  Optimized: boolean | null;
  Placeholder1Position: number | null;
  AdditionLength: number | null;
  ArticleNumberPosition: number | null;
  Description: string | null;
  UnitLengthLength: number | null;
  MillimeterValues: boolean | null;
  SizePosition: number | null;
  RequestNumberPosition: number | null;
  ProductionDateLength: number | null;
  Placeholder2Length: number | null;
  GeometryPosition: number | null;
  OuterLaminationLength: number | null;
  DescriptionLength: number | null;
  ColorNumberLength: number | null;
  SizeLength: number | null;
  WidthLength: number | null;
  SealPosition: number | null;
  VekaIdPosition: number | null;
  InnerLaminationPosition: number | null;
  CustomerNumberLength: number | null;
  InnerLaminationLength: number | null;
  CustomerNumberPosition: number | null;
  Placeholder1Length: number | null;
  ArticleNumberLength: number | null;
  AmountPosition: number | null;
  FileType: string | null;
}

export interface Product {
  ReservedAmount: number | null;
  SubstituteArticleName: string | null;
  ColorNumber: string | null;
  SubstituteArticleGuid: string | null;
  SealColorName: string | null;
  IsStockManaged: boolean | null;
  SealNumber: string | null;
  SubstituteArticleNumber: string | null;
  CreatedAt: string | null;
  DefaultConditionGuid: string | null;
  CarrierName: string | null;
  InventoryBackupStock: number | null;
  CarrierGuid: string | null;
  BaseUnitGuid: string | null;
  Property: string | null;
  SealColorGuid: string | null;
  OuterLaminationName: string | null;
  IsDisabled: boolean | null;
  OuterLaminationGuid: string | null;
  ArticleGuid: string | null;
  AdditionalEquipmentGuid: string | null;
  BaseUnitName: string | null;
  AdditionalEquipmentName: string | null;
  OuterLaminationNumber: string | null;
  BaseAmount: number | null;
  MinStock: number | null;
  SealGuid: string | null;
  CreationType: CreationType | null;
  SealName: string | null;
  GeometryName: string | null;
  InnerLaminationName: string | null;
  GeometryGuid: string | null;
  MaxStock: number | null;
  Name: string | null;
  Guid: string | null;
  InnerLaminationGuid: string | null;
  OrderedAmount: number | null;
  Offcut: number | null;
  SubstituteVariantName: string | null;
  InnerLaminationNumber: string | null;
  InventoryStock: number | null;
  InstallationHeightNumber: string | null;
  CarrierNumber: string | null;
  Ean: string | null;
  ArticleNumber: string | null;
  SubstituteVariantGuid: string | null;
  IsCommissionArticle: boolean | null;
  ExcludedFromRequirement: boolean | null;
  OrderRequirement: number | null;
  ArticleName: string | null;
  BaseUnitDecimalValue: boolean | null;
  AdditionalEquipmentNumber: string | null;
  InstallationHeightName: string | null;
  InstallationHeightGuid: string | null;
  IsNameManuallySet: boolean | null;
  SealColorNumber: string | null;
  OrderIndex: number | null;
  CurrentStock: number | null;
  DefaultStockGuid: string | null;
  GeometryNumber: string | null;
  ShortProperty: string | null;
  OrderPositionDetails?: Array<OrderPosition>;
  SupplierConditionDetails?: Array<SupplierCondition>;
  ArticleDetails?: Article | null;
  StockLocationMappingDetails?: Array<ProductStockLocationMapping>;
}

export interface ImportDataSolution {
  ArticleGuid: string | null;
  ColorNumber: string | null;
  ArticleName: string | null;
  SealColor: string | null;
  Seal: string | null;
  ProductGuid: string | null;
  OuterLamination: string | null;
  ProductName: string | null;
  Carrier: string | null;
  UnitLength: number | null;
  ArticleNumber: string | null;
  Guid: string | null;
  Geometry: string | null;
  InnerLamination: string | null;
  VekaId: string | null;
  Addition: string | null;
}

export interface RequestEprod {
  RequestNumber: string | null;
  ImportDate: string | null;
  Imported: boolean | null;
  Guid: string | null;
  TimestampString: string | null;
  Timestamp: string | null;
}

export interface KlaesSupplier {
  SupplierName: string | null;
  SupplierGuid: string | null;
  Guid: string | null;
  Exclude: boolean | null;
  Token: string | null;
}

export interface OrderPosition {
  SupplierOrderNumber: string | null;
  OrderNumber: string | null;
  MeasurementUnitName: string | null;
  MeasurementUnitGuid: string | null;
  PositionDiscount: number | null;
  ProductGuid: string | null;
  ClosedOrder: boolean | null;
  Delivered: boolean | null;
  ConfirmedUnits: number | null;
  ConfirmedDeliveryDate: string | null;
  DeliveryNoteDeliveredAmount: number | null;
  RequestNumber: string | null;
  PriceUnitGuid: string | null;
  MinOrderAmount: number | null;
  BaseUnitGuid: string | null;
  DeliveryEndDate: string | null;
  SupplierConditionGuid: string | null;
  SupplierOuterLaminationNumber: string | null;
  ConfirmedTaxAmount: number | null;
  ArticleGuid: string | null;
  PositionBaseUnitName: string | null;
  ConfirmedCarrier: string | null;
  SupplierInnerLaminationNumber: string | null;
  ConfirmedTaxPercentage: number | null;
  Index: number | null;
  ConfirmedInnerLamination: string | null;
  Completed: boolean | null;
  BaseUnitName: string | null;
  OrderedUnits: number | null;
  BaseAmount: number | null;
  DeliveredAt: string | null;
  RequestPositionNoteHeigth: string | null;
  OrderedAt: string | null;
  ConfirmedPrice: number | null;
  ConfirmedAmount: number | null;
  RequiredAmount: number | null;
  SupplierInnerLaminationGuid: string | null;
  Guid: string | null;
  OrderedPid: string | null;
  OrderedAmount: number | null;
  VariantName: string | null;
  UnitDividerUnitGuid: string | null;
  PackingName: string | null;
  Status: string | null;
  RequestPositionNoteSize: string | null;
  OrderExpectedAt: string | null;
  ConfirmedUnitName: string | null;
  SupplierOuterLaminationGuid: string | null;
  PackingUnitName: string | null;
  SupplierOuterLaminationName: string | null;
  SupplierCarrierNumber: string | null;
  UnitDivider: number | null;
  OrderStatus: string | null;
  ConfirmedUnitGuid: string | null;
  OriginalPackingUnitGuid: string | null;
  SupplierInnerLaminationName: string | null;
  PackingUnitGuid: string | null;
  PriceFactor: number | null;
  OriginalOrderedUnits: number | null;
  OrderGuid: string | null;
  ArticleNumber: string | null;
  PackingUnitFactor: number | null;
  ConfirmedOuterLamination: string | null;
  RequestPositionNoteWidth: string | null;
  ConfirmedSupplierArticleNumber: string | null;
  Commission: string | null;
  PackingUnitPrice: number | null;
  DeliveredAmount: number | null;
  SupplierName: string | null;
  Ordered: boolean | null;
  SupplierGuid: string | null;
  ArticleName: string | null;
  OrderSupplierName: string | null;
  RequiredAmountToBase: number | null;
  OriginalOrderedAmount: number | null;
  CustomerPrice: number | null;
  OpenAmount: number | null;
  OpenDeliverAmount: number | null;
  SupplierArticleNumber: string | null;
  ProductIsDeleted: boolean | null;
  DeliveryNotePositions: string | null;
  PositionDefaultPrice: number | null;
  SupplierCarrierName: string | null;
  CurrentStock: number | null;
  SupplierCarrierGuid: string | null;
  PackingUnitSapCode: string | null;
  RequestPositionNoteLength: string | null;
  HasRequestPositions: boolean | null;
  Product?: Product | null;
  OrderDetail?: VaasOrder | null;
}

export interface Module {
  ModuleType: ModuleType | null;
  Guid: string | null;
  Enabled: boolean | null;
}

export interface RequestNote {
  Note: string | null;
  CreatedAt: string | null;
  Amount: number | null;
  RequestNumber: string | null;
  Size: number | null;
  Width: number | null;
  Length: number | null;
  ProductGuid: string | null;
  Guid: string | null;
  Height: number | null;
}

export interface VVekaSap {
  SapArtikelNr: string | null;
  Nettopreis: number | null;
  LieferCode: string | null;
  FarbNrErw: string | null;
  Rolladen: boolean | null;
  TeilMerkmal: string | null;
  Stangenlaenge: number | null;
  TraegerId: string | null;
  ArtikelNr: string | null;
  VerpackCode: string | null;
  ZusatzId: string | null;
  Konfig: boolean | null;
  FolieInnen: string | null;
  FolieAussen: string | null;
  Bezeichnung: string | null;
  DichtFarbId: string | null;
  DichtungId: string | null;
  GeometId: string | null;
  Profilsystem: string | null;
  Anlegen: boolean | null;
  KlaesArtikel: string | null;
  Guid: string | null;
  ArtikelNr6: string | null;
  Merkmal: string | null;
  EinheitCode: string | null;
}

export interface ProductSubstitution {
  SubstituteArticleName: string | null;
  ColorNumber: string | null;
  CarrierNumber: string | null;
  ArticleNumber: string | null;
  SubstituteArticleGuid: string | null;
  SubstituteVariantName: string | null;
  Property: string | null;
  Guid: string | null;
  SubstituteGuid: string | null;
  SubstituteArticleNumber: string | null;
}

export interface StockLocation {
  Hidden: boolean | null;
  ParentGuid: string | null;
  Name: string | null;
  Guid: string | null;
  Leaf: boolean | null;
  ParentLocation?: StockLocation | null;
  ProductMappingDetails?: Array<ProductStockLocationMapping>;
  ChildLocations?: Array<StockLocation>;
}

export interface SupplierNumberSubstitution {
  SupplierArticleNumber: string | null;
  Guid: string | null;
  SubstituteSupplierArticleNumber: string | null;
}

export interface ImportStockLog {
  FileName: string | null;
  ProductAmount: number | null;
  ArticleNumber: string | null;
  ProductProperty: string | null;
  Guid: string | null;
  Time: string | null;
  ImportAmount: number | null;
}

export interface OldProductSubstitution {
  Date: string | null;
  SubstituteArticleName: string | null;
  OldVariantName: string | null;
  OldGuid: string | null;
  OldArticleNumber: string | null;
  SubstituteArticleGuid: string | null;
  OldArticleGuid: string | null;
  SubstituteVariantName: string | null;
  Guid: string | null;
  OldArticleName: string | null;
  SubstituteGuid: string | null;
  SubstituteArticleNumber: string | null;
}

export interface DeliveryNote {
  SupplierName: string | null;
  Number: string | null;
  SupplierGuid: string | null;
  TotalItems: number | null;
  OrderNumber: string | null;
  Booked: boolean | null;
  DeliveryStartDate: string | null;
  Guid: string | null;
  DeliveryEndDate: string | null;
  NotificationDate: string | null;
  AccumulatedPositionStatus: VaasOrderStatus | null;
  SupplierDetail?: Supplier | null;
}

export interface ScheduledImport {
  SupplierName: string | null;
  SupplierGuid: string | null;
  ImportedAt: string | null;
  HasMissingTokens: boolean | null;
  MaterialGroupGuid: string | null;
  KlaesSuppliers: string | null;
  PlannedAt: string | null;
  Language: string | null;
  MaterialGroupName: string | null;
  Type: ImportType | null;
  CreatedAt: string | null;
  Name: string | null;
  Guid: string | null;
  Status: ImportStatus | null;
}

export interface SealColor {
  Number: string | null;
  DisplayName: string | null;
  Name: string | null;
  Guid: string | null;
}

export interface InvoicePosition {
  DeliveredAmount: number | null;
  DeliveryNotePositionGuid: string | null;
  DeliveredUnits: number | null;
  UnitGuid: string | null;
  TaxPercentage: number | null;
  SupplierPid: string | null;
  InvoiceGuid: string | null;
  ChargedBaseAmount: number | null;
  SinglePrice: number | null;
  Price: number | null;
  Guid: string | null;
  PositionIndex: number | null;
  TaxAmount: number | null;
  InvoiceDetail?: Invoice | null;
  DeliveryNotePositionDetail?: DeliveryNotePosition | null;
  UnitDetail?: MeasurementUnit | null;
}

export interface Customer {
  Zip: string | null;
  Country: string | null;
  City: string | null;
  ContactPerson: string | null;
  FullName: string | null;
  CustomerNumber: string | null;
  FirstName: string | null;
  Phone: string | null;
  Street: string | null;
  Name: string | null;
  Guid: string | null;
  Comment: string | null;
  Fax: string | null;
  Email: string | null;
}

export interface Supplier {
  Zip: string | null;
  Country: string | null;
  OpenTransOrderConfirmationPrefix: string | null;
  City: string | null;
  UseUdxSalesText: boolean | null;
  CompleteDeliveryByDefault: boolean | null;
  ContactPerson: string | null;
  OpenTransSupplierNumber: string | null;
  EdiEnabled: boolean | null;
  OpenTransInvoicePrefix: string | null;
  OrderPeriod: number | null;
  CriticalOrderPeriod: number | null;
  ShowPriceInOrder: boolean | null;
  OpenTransDeliveryNotePrefix: string | null;
  OpenTransParty: OpenTransParty | null;
  Phone: string | null;
  Street: string | null;
  UseOpenTransInOrder: boolean | null;
  Name: string | null;
  Guid: string | null;
  Fax: string | null;
  AgNumber: string | null;
  OpenTransVersion2005: boolean | null;
  Email: string | null;
  GoodsRecipientDetails?: Array<GoodsRecipient>;
  RecipientNumberDetails?: Array<SupplierRecipientNumber>;
  OrderDetails?: Array<VaasOrder>;
}

export interface Message {
  MessageKey: MessageKey | null;
  MessageType: MessageType | null;
  Unread: boolean | null;
  ReplacementContent: string | null;
  CreatedByUserGuid: string | null;
  Guid: string | null;
  UserGuid: string | null;
  Type: Type | null;
  CreatedOn: string | null;
}

export interface PackingUnit {
  UnitPrice: number | null;
  SupplierName: string | null;
  SupplierGuid: string | null;
  DeliveryTime: number | null;
  MeasurementUnitName: string | null;
  MeasurementUnitGuid: string | null;
  SingleAmount: number | null;
  MeasurementUnitSapCode: string | null;
  PackingSapCode: string | null;
  BaseUnitName: string | null;
  IsDecimalValue: boolean | null;
  BaseAmount: number | null;
  PriceFactor: number | null;
  PriceUnitGuid: string | null;
  SupplierArticleNumber: string | null;
  BaseUnitGuid: string | null;
  Guid: string | null;
  Factor: number | null;
  SupplierConditionGuid: string | null;
  PackingName: string | null;
  SupplierUsesBmecat: boolean | null;
  SupplierConditionDetail?: SupplierCondition | null;
}

export interface DiscontinuedArticle {
  Ignored: boolean | null;
  ArticleName: string | null;
  IsStockManaged: boolean | null;
  ProductGuid: string | null;
  ReplacementGuid: string | null;
  IgnoredByGuid: string | null;
  BaseUnitName: string | null;
  Version: string | null;
  OpenOrderPositionCount: number | null;
  UnextractedRequestPositionCount: number | null;
  IgnoredAt: string | null;
  ArticleNumber: string | null;
  IgnoreReason: string | null;
  Variant: string | null;
  CurrentStock: number | null;
  Guid: string | null;
  Status: string | null;
  ProductDetail?: Product | null;
}

export interface Client {
  Zip: string | null;
  Country: string | null;
  IsDeliveryTimeChangeable: boolean | null;
  City: string | null;
  Street: string | null;
  Name: string | null;
  Guid: string | null;
}

export interface RequestImportFilter {
  Filter: string | null;
  Guid: string | null;
  Exclude: boolean | null;
}

export interface Stock {
  ReservedAmount: number | null;
  IsStockManaged: boolean | null;
  ProductGuid: string | null;
  ProductName: string | null;
  StockValue: number | null;
  BaseUnitIsDecimalUnit: boolean | null;
  Ean: string | null;
  IsDeleted: boolean | null;
  ArticleNumber: string | null;
  Price: number | null;
  BaseUnitGuid: string | null;
  Property: string | null;
  ArticleGuid: string | null;
  OrderRequirement: number | null;
  ArticleName: string | null;
  MaterialGroupGuid: string | null;
  StockLocations: string | null;
  ProductGroupName: string | null;
  ProductGroupGuid: string | null;
  MaterialGroupName: string | null;
  AssignedToOrder: number | null;
  BaseUnitName: string | null;
  BaseAmount: number | null;
  OpenAmount: number | null;
  MinStock: number | null;
  MaxStock: number | null;
  CurrentStock: number | null;
  Guid: string | null;
  OrderedAmount: number | null;
  ProductCategoryDetails?: Array<ProductCategory>;
  StockLocationDetails?: Array<StockLocation>;
  SupplierConditionDetails?: Array<SupplierCondition>;
  ArticleDetails?: Article | null;
}

export interface SupplierCondition {
  DefaultOrderUnitSapCode: string | null;
  DeliveryTime: number | null;
  DefaultOrderUnitGuid: string | null;
  ChangeDefaultPrice: string | null;
  DefaultCondition: boolean | null;
  UnitDividerUnitName: string | null;
  UnitDivider: number | null;
  UnitDividerUnitSapCode: string | null;
  ProductGuid: string | null;
  Discount: number | null;
  PackingSapCode: string | null;
  MinOrderUnitName: string | null;
  DeliveryTimeCodeGuid: string | null;
  PriceFactor: number | null;
  ChangeDiscount: string | null;
  MinOrderAmount: number | null;
  BaseUnitGuid: string | null;
  DefaultPriceUnitName: string | null;
  DefaultPriceUnitGuid: string | null;
  MinOrderUnitSapCode: string | null;
  SupplierName: string | null;
  SupplierGuid: string | null;
  DefaultPrice: number | null;
  DefaultOrderAmount: number | null;
  GoodsRecipientGuid: string | null;
  ChangeDeliveryTime: string | null;
  GrantedTill: string | null;
  BaseUnitName: string | null;
  SpecialSupplierArticleNumber: boolean | null;
  CreationType: CreationType | null;
  SapArticle: boolean | null;
  SupplierArticleNumber: string | null;
  MinOrderUnitGuid: string | null;
  PackingGuid: string | null;
  UnitChange: number | null;
  Guid: string | null;
  IsManuallyChanged: boolean | null;
  DefaultOrderUnitName: string | null;
  UnitDividerUnitGuid: string | null;
  BaseUnitSapCode: string | null;
  PackingName: string | null;
  AppliedAt: string | null;
  SpectralSupplierArticleNumber: boolean | null;
  ProductDetail?: Product | null;
  SupplierDetails?: Supplier | null;
}

export interface Request {
  AwardedAt: string | null;
  ImportProblems: boolean | null;
  IsReady: boolean | null;
  Delivered: boolean | null;
  Extracted: boolean | null;
  IsCommissionRequest: boolean | null;
  Number: string | null;
  CreatedAt: string | null;
  ProductionDate: string | null;
  Price: number | null;
  RequirementMade: boolean | null;
  CompletelyDelivered: boolean | null;
  Ordered: boolean | null;
  CompletelyRequired: boolean | null;
  CompletedAt: string | null;
  CustomerGuid: string | null;
  DeliveredPositionsCount: number | null;
  CompletePositionsCount: number | null;
  CustomerName: string | null;
  CoveredPositionsCount: number | null;
  ShippingTicket: boolean | null;
  CommissionName: string | null;
  CommissionGuid: string | null;
  Canceled: boolean | null;
  MarkedForExtraction: boolean | null;
  Closed: boolean | null;
  OrderedPositionsCount: number | null;
  Guid: string | null;
  Comment: string | null;
  StockAvailability: number | null;
}

export interface Invoice {
  TotalSum: number | null;
  SupplierName: string | null;
  TaxRate: number | null;
  SupplierGuid: string | null;
  Number: string | null;
  Guid: string | null;
  Currency: string | null;
  NettoSum: number | null;
  TaxAmount: number | null;
  InvoiceDate: string | null;
}

export interface UserRole {
  Name: string | null;
  Guid: string | null;
}

export interface AdditionalEquipment {
  Number: string | null;
  DisplayName: string | null;
  Name: string | null;
  Guid: string | null;
}

export interface ProductStockLocationMapping {
  ProductGuid: string | null;
  Guid: string | null;
  StockLocationGuid: string | null;
  ProductDetail?: Product | null;
  StockLocationDetail?: StockLocation | null;
}

export interface ProductGroup {
  Number: string | null;
  SeparateOrder: boolean | null;
  Description: string | null;
  Guid: string | null;
}

export interface GoodsRecipient {
  Number: string | null;
  SupplierGuid: string | null;
  Guid: string | null;
  IsDefaultRecipient: boolean | null;
  SupplierDetail?: Supplier | null;
}

export interface RequestPosition {
  ConfirmedDelivery: string | null;
  SupplierOrderNumber: string | null;
  ReservedAmount: number | null;
  OrderNumber: string | null;
  RequestPositionNoteHeight: number | null;
  IsStockManaged: boolean | null;
  ProductGuid: string | null;
  Delivered: boolean | null;
  Extracted: boolean | null;
  RequestNumber: string | null;
  DefaultConditionGuid: string | null;
  BaseUnitGuid: string | null;
  OrderPositionConditionGuid: string | null;
  ExtractedAt: string | null;
  ArticleGuid: string | null;
  CustomerGuid: string | null;
  OnStock: boolean | null;
  MaterialGroupGuid: string | null;
  MaterialGroupName: string | null;
  Completed: boolean | null;
  BaseUnitName: string | null;
  OrderedUnits: number | null;
  BaseAmount: number | null;
  CustomerName: string | null;
  DeliveredAt: string | null;
  OrderedAt: string | null;
  Canceled: boolean | null;
  OrderCompleted: boolean | null;
  WithOffcut: number | null;
  OrderPositionGuid: string | null;
  Guid: string | null;
  VariantName: string | null;
  OrderedAmount: number | null;
  RequestGuid: string | null;
  RequestPositionNoteSize: number | null;
  DeliveryTime: number | null;
  Optimized: boolean | null;
  OrderPositionIndex: number | null;
  ProductionDate: string | null;
  ExpectedDelivery: string | null;
  OrderGuid: string | null;
  RequestedAt: string | null;
  ArticleNumber: string | null;
  RequirementMade: boolean | null;
  RequestPositionNoteGuid: string | null;
  RequestPositionNoteWidth: number | null;
  IsCommissionArticle: boolean | null;
  DeliveredAmount: number | null;
  Ordered: boolean | null;
  Amount: number | null;
  ArticleName: string | null;
  Replaced: boolean | null;
  DeliveryNotePosition: string | null;
  CustomerPrice: number | null;
  OpenOrderedAmount: number | null;
  CurrentStock: number | null;
  RequestPositionNoteLength: number | null;
  StockAvailability: number | null;
  ProductDetails?: Product | null;
  DefaultConditionDetails?: SupplierCondition | null;
  RequestPositionDeliveryDetails?: Array<RequestPositionDelivery>;
  OrderPositionConditionDetails?: SupplierCondition | null;
}

export interface ArticleSupplierConditionMapping {
  ArticleGuid: string | null;
  SupplierConditionGuid: string | null;
}

export interface ArticleSubstitution {
  SubstituteName: string | null;
  SubstituteNumber: string | null;
  ArticleNumber: string | null;
  Guid: string | null;
  SubstituteGuid: string | null;
}

export interface Commission {
  ProductionEnd: string | null;
  Note: string | null;
  Assignment: string | null;
  Name: string | null;
  ProductionStart: string | null;
  Guid: string | null;
}

export interface VaasOrder {
  ConfirmedDelivery: string | null;
  SupplierOrderNumber: string | null;
  BookedDeliveryNoteNumbers: string | null;
  OrderType: OrderType | null;
  Note: string | null;
  OrderNumber: string | null;
  DeliveryTime: number | null;
  DesiredDelivery: string | null;
  HasMultipleDates: boolean | null;
  PromisedDelivery: string | null;
  Delivered: boolean | null;
  Confirmed: boolean | null;
  CreatedAt: string | null;
  ShowPriceInOrder: boolean | null;
  ExpectedDelivery: string | null;
  ReferenceNumber: string | null;
  Price: number | null;
  HasMissingPositions: boolean | null;
  StatusOfDelivery: OrderDeliveryStatus | null;
  Commission: string | null;
  DeliveryEndDate: string | null;
  OpenTransVersion2005: string | null;
  AccumulatedPositionStatus: VaasOrderStatus | null;
  Payed: boolean | null;
  Overdelivered: boolean | null;
  SupplierName: string | null;
  ConfirmationRead: boolean | null;
  SupplierGuid: string | null;
  Ordered: boolean | null;
  GoodsRecipientGuid: string | null;
  UseUdxSalesText: boolean | null;
  DeliveryStartDate: string | null;
  Underdelivered: boolean | null;
  OpenTransUri: string | null;
  ProductGroupGuid: string | null;
  ConfirmedNettoSum: number | null;
  OrderPositionCount: number | null;
  EdiEnabled: boolean | null;
  DeliveredAt: string | null;
  OrderedAt: string | null;
  IsOverdue: boolean | null;
  OpenDeliveryNoteNumbers: string | null;
  Closed: boolean | null;
  Guid: string | null;
  DeliveryNotePositionCount: number | null;
  ConfirmedAt: string | null;
  CompleteDelivery: boolean | null;
  Status: string | null;
  OrderPositionDetails?: Array<OrderPosition>;
  SupplierDetail?: Supplier | null;
}

export interface StockDailyRequirement {
  DailyReservedAmount: number | null;
  Guid: string | null;
}

export interface ImportProblem {
  ColorNumber: string | null;
  SealColorName: string | null;
  InnerLaminationNumber: string | null;
  SealNumber: string | null;
  Description: string | null;
  MillimeterValues: boolean | null;
  CarrierNumber: string | null;
  RequestNumber: string | null;
  ProductionDate: string | null;
  UnitLength: number | null;
  CarrierName: string | null;
  CarrierGuid: string | null;
  ArticleNumber: string | null;
  Property: string | null;
  OuterLaminationName: string | null;
  SealColorGuid: string | null;
  FileFormatGuid: string | null;
  VekaId: string | null;
  OuterLaminationGuid: string | null;
  Height: number | null;
  ArticleGuid: string | null;
  Amount: number | null;
  ArticleName: string | null;
  AdditionalEquipmentNumber: string | null;
  Length: number | null;
  IsArticleNumberGenerated: boolean | null;
  MaterialGroupName: string | null;
  AdditionalEquipmentGuid: string | null;
  AdditionalEquipmentName: string | null;
  OuterLaminationNumber: string | null;
  SealColorNumber: string | null;
  SealGuid: string | null;
  SealName: string | null;
  GeometryName: string | null;
  Size: number | null;
  InnerLaminationName: string | null;
  GeometryGuid: string | null;
  Width: number | null;
  ConfigurableArticle: boolean | null;
  Guid: string | null;
  Position: number | null;
  InnerLaminationGuid: string | null;
  GeometryNumber: string | null;
  RequestGuid: string | null;
}

export interface ArticleImportFilter {
  Filter: string | null;
  Guid: string | null;
  Exclude: boolean | null;
}

export interface MaterialGroup {
  PropertiesAvailable: boolean | null;
  Name: string | null;
  Guid: string | null;
}

export interface ExpectedDelivery {
  OrderNumber: string | null;
  ProductGuid: string | null;
  PositionGuid: string | null;
  OrderPositionIndex: number | null;
  OrderGuid: string | null;
  ArticleNumber: string | null;
  ExpectedFor: string | null;
  SupplierName: string | null;
  ArticleGuid: string | null;
  SupplierGuid: string | null;
  Amount: number | null;
  ArticleName: string | null;
  UnitName: string | null;
  MaterialGroupGuid: string | null;
  ProductGroupGuid: string | null;
  MaterialGroupName: string | null;
  OpenAmount: number | null;
  BaseAmount: number | null;
  OrderedAt: string | null;
  ProductGroup: string | null;
  RequiredAmount: number | null;
  CurrentStock: number | null;
  Guid: string | null;
  OrderedAmount: number | null;
  VariantName: string | null;
}

export interface Packing {
  SapCode: string | null;
  DisplayName: string | null;
  Name: string | null;
  Guid: string | null;
}

export interface MeasurementUnit {
  SapCode: string | null;
  DecimalValue: boolean | null;
  Name: string | null;
  Guid: string | null;
  OpenTransUnitCode: string | null;
}

export interface CustomerFileFormat {
  ZipLength: number | null;
  CommentPosition: number | null;
  EmailPosition: number | null;
  FirstNameLength: number | null;
  CustomerNumberLength: number | null;
  CustomerFormat: boolean | null;
  PhoneLength: number | null;
  ZipPosition: number | null;
  CustomerNumberPosition: number | null;
  FaxPosition: number | null;
  StreetPosition: number | null;
  NameLength: number | null;
  CityLength: number | null;
  PhonePosition: number | null;
  FirstNamePosition: number | null;
  FaxLength: number | null;
  StreetLength: number | null;
  CityPosition: number | null;
  Guid: string | null;
  NamePosition: number | null;
  CommentLength: number | null;
  FileType: string | null;
  EmailLength: number | null;
}

export interface Lamination {
  CreationType: CreationType | null;
  Number: string | null;
  DisplayName: string | null;
  LaminationType: LaminationType | null;
  Name: string | null;
  Guid: string | null;
  SpecialLamination: boolean | null;
}

export interface DeliveryNotePosition {
  BookedAmount: number | null;
  OrderNumber: string | null;
  Booked: boolean | null;
  OrderedCarrier: string | null;
  DeliveredUnits: number | null;
  OrderedInnerLamination: string | null;
  OrderedBaseAmount: number | null;
  DeliveredOuterLamination: string | null;
  SupplierPid: string | null;
  ConfirmedUnits: number | null;
  BaseUnit: string | null;
  OrderPositionNumber: number | null;
  OrderGuid: string | null;
  ArticleNumber: string | null;
  ConfirmedOuterLamination: string | null;
  ConfirmedUnit: string | null;
  DeliveredAmount: number | null;
  DeliveredUnit: string | null;
  ArticleName: string | null;
  UnitGuid: string | null;
  OrderedUnit: string | null;
  DeliveredInnerLamination: string | null;
  DescriptionShort: string | null;
  OrderedUnits: number | null;
  DeliveredCarrier: string | null;
  OrderPositionGuid: string | null;
  DeliveryNoteGuid: string | null;
  Guid: string | null;
  PositionIndex: number | null;
  VariantName: string | null;
  OrderedPID: string | null;
  DeliveryNoteNumber: string | null;
  DeliveryNoteDetail?: DeliveryNote | null;
  OrderPositionDetail?: OrderPosition | null;
  MeasurementUnitDetail?: MeasurementUnit | null;
}

export interface RequiredStock {
  ReservedAmount: number | null;
  DeliveryTime: number | null;
  IsStockManaged: boolean | null;
  ProductGuid: string | null;
  RequiredOrderAmount: number | null;
  CategoryName: string | null;
  NoConditions: boolean | null;
  ProductName: string | null;
  DefaultConditionGuid: string | null;
  ProductionDate: string | null;
  ArticleNumber: string | null;
  BaseUnitGuid: string | null;
  ExcludedFromRequirement: boolean | null;
  ArticleGuid: string | null;
  ArticleName: string | null;
  MaterialGroupGuid: string | null;
  StockLocations: string | null;
  MultipleConditions: boolean | null;
  MaterialGroupName: string | null;
  BaseUnitName: string | null;
  BaseAmount: number | null;
  MinStock: number | null;
  CurrentStock: number | null;
  Guid: string | null;
  OrderedAmount: number | null;
}

export interface ArticleGoodsRecipientPK {
  ArticleGuid: string | null;
  GoodsRecipientGuid: string | null;
}

export interface ProductTemplateAdditionalEquipmentPK {
  TemplatesAvailableInGuid: string | null;
  AvailableAdditionsGuid: string | null;
}

export interface ProductTemplateSealColorPK {
  TemplatesAvailableInGuid: string | null;
  AvailableSealColorsGuid: string | null;
}

export interface ProductTemplateLaminationPK {
  AvailableLaminationsGuid: string | null;
  TemplatesAvailableInGuid: string | null;
}

export interface ProductTemplateCarrierPK {
  TemplatesAvailableInGuid: string | null;
  AvailableCarriersGuid: string | null;
}

export interface ArticleSupplierConditionMappingViewPK {
  ArticleGuid: string | null;
  SupplierConditionGuid: string | null;
}

export interface ProductTemplateGeometryPK {
  TemplatesAvailableInGuid: string | null;
  AvailableGeometriesGuid: string | null;
}

export interface ProductTemplateSealPK {
  TemplatesAvailableInGuid: string | null;
  AvailableSealsGuid: string | null;
}
